// Centralized lodash imports - much cleaner!
import {
  filter,
  isEmpty,
  concat,
  merge,
  map,
  slice,
  difference,
  findIndex,
} from '@/utils/lodash'

import {Card, CardContent, Divider, Typography, Box } from '@mui/material'

function usePreferences({ activeOrg = {} }) {
  const buyAndHoldCards = filter(
    [
      {
        name: 'strategy',
        card: (
          <img
            src="/images/buyAndHoldCards/Summary.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'targets',
        card: (
          <img
            src="/images/buyAndHoldCards/Targets.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'monthlyCashflow',
        card: (
          <img
            src="/images/buyAndHoldCards/Cashflow.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'acquisition',
        card: (
          <img
            src="/images/buyAndHoldCards/AcquisitionExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'income',
        card: (
          <img
            src="/images/buyAndHoldCards/Income.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'expenses',
        card: (
          <img
            src="/images/buyAndHoldCards/MonthlyExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'rehab',
        card: (
          <img
            src="/images/buyAndHoldCards/RehabExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'financing',
        card: (
          <img
            src="/images/buyAndHoldCards/Financing.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'projection',
        card: (
          <img
            src="/images/buyAndHoldCards/Assumptions.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'cashPositioning',
        card: (
          <img
            src="/images/buyAndHoldCards/CashPositioning.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'disposition',
        card: (
          <img
            src="/images/fixAndFlipCards/DispositionExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'comparableProperties',
        card: (
          <img
            src="/images/universalStrategyCards/CompsCard.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'deactive',
        card: (
          <Card variant="outlined" sx={{ width: '100%' }}>
            <div
              style={{ display: 'flex', alignItems: 'center', paddingTop: '0.75rem', paddingBottom: '0.75rem', paddingLeft: '1.25rem', paddingRight: '1.25rem', marginBottom: 5, marginTop: 5, backgroundColor: '#fff' }}
            >
              <Box sx={{
                flexGrow: 1,
                minWidth: 0,
                "& > b": { display: "block" },
                "& > small": {
                  textTransform: "uppercase",
                  display: "block",
                  opacity: 0.3,
                  fontWeight: "bold",
                },
              }}>
                <b>Hide Cards</b>
              </Box>
            </div>
            <Divider />
            <CardContent>
              <Typography>
                All cards past this one will be hidden
              </Typography>
            </CardContent>
          </Card>
        ),
      },
    ],
    (card) => !card.hide,
  )

  const fixAndFlipCards = filter(
    [
      {
        name: 'bigPicture',
        hide: !activeOrg?.isRealeflow,
        card: (
          <img
            src="/images/fixAndFlipCards/BigPicture.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'bigPictureSummary',
        hide: !activeOrg?.isRealeflow,
        card: (
          <img
            src="/images/fixAndFlipCards/BigPictureSummary.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'strategy',
        card: (
          <img
            src="/images/fixAndFlipCards/Summary.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'targets',
        card: (
          <img
            src="/images/fixAndFlipCards/Targets.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'netProfit',
        card: (
          <img
            src="/images/fixAndFlipCards/NetProfit.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'acquisition',
        card: (
          <img
            src="/images/fixAndFlipCards/AcquisitionExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'income',
        card: (
          <img
            src="/images/fixAndFlipCards/Income.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'rehab',
        card: (
          <img
            src="/images/fixAndFlipCards/RehabExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'holding',
        card: (
          <img
            src="/images/fixAndFlipCards/HoldingExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'financing',
        card: (
          <img
            src="/images/fixAndFlipCards/Financing.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'disposition',
        card: (
          <img
            src="/images/fixAndFlipCards/DispositionExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'comparableProperties',
        card: (
          <img
            src="/images/universalStrategyCards/CompsCard.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'deactive',
        card: (
          <Card variant="outlined" sx={{ width: '100%' }}>
            <div
              style={{ display: 'flex', alignItems: 'center', paddingTop: '0.75rem', paddingBottom: '0.75rem', paddingLeft: '1.25rem', paddingRight: '1.25rem', marginBottom: 5, marginTop: 5, backgroundColor: '#fff' }}
            >
              <Box sx={{
                flexGrow: 1,
                minWidth: 0,
                "& > b": { display: "block" },
                "& > small": {
                  textTransform: "uppercase",
                  display: "block",
                  opacity: 0.3,
                  fontWeight: "bold",
                },
              }}>
                <b>Hide Cards</b>
              </Box>
            </div>
            <Divider />
            <CardContent>
              <Typography>
                All cards past this one will be hidden
              </Typography>
            </CardContent>
          </Card>
        ),
      },
    ],
    (card) => !card.hide,
  )

  const turnkeyCards = filter(
    [
      {
        name: 'strategy',
        card: (
          <img
            src="/images/turnkeyCards/Summary.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'targets',
        card: (
          <img
            src="/images/turnkeyCards/Targets.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'monthlyCashflow',
        card: (
          <img
            src="/images/turnkeyCards/Cashflow.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'acquisition',
        card: (
          <img
            src="/images/turnkeyCards/AcquisitionExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'income',
        card: (
          <img
            src="/images/turnkeyCards/Income.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'expenses',
        card: (
          <img
            src="/images/turnkeyCards/MonthlyExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'rehab',
        card: (
          <img
            src="/images/turnkeyCards/RehabExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'financing',
        card: (
          <img
            src="/images/turnkeyCards/Financing.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'projection',
        card: (
          <img
            src="/images/turnkeyCards/Assumptions.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'cashPositioning',
        card: (
          <img
            src="/images/buyAndHoldCards/CashPositioning.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'disposition',
        card: (
          <img
            src="/images/fixAndFlipCards/DispositionExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'comparableProperties',
        card: (
          <img
            src="/images/universalStrategyCards/CompsCard.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'deactive',
        card: (
          <Card variant="outlined" sx={{ width: '100%' }}>
            <div
              style={{ display: 'flex', alignItems: 'center', paddingTop: '0.75rem', paddingBottom: '0.75rem', paddingLeft: '1.25rem', paddingRight: '1.25rem', marginBottom: 5, marginTop: 5, backgroundColor: '#fff' }}
            >
              <Box sx={{
                flexGrow: 1,
                minWidth: 0,
                "& > b": { display: "block" },
                "& > small": {
                  textTransform: "uppercase",
                  display: "block",
                  opacity: 0.3,
                  fontWeight: "bold",
                },
              }}>
                <b>Hide Cards</b>
              </Box>
            </div>
            <Divider />
            <CardContent>
              <Typography>
                All cards past this one will be hidden
              </Typography>
            </CardContent>
          </Card>
        ),
      },
    ],
    (card) => !card.hide,
  )

  const BRRRRCards = filter(
    [
      {
        name: 'strategy',
        card: (
          <img
            src="/images/BRRRRCards/Strategy.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'targets',
        card: (
          <img
            src="/images/BRRRRCards/Targets.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'monthlyCashflow',
        card: (
          <img
            src="/images/BRRRRCards/MonthlyCashflow.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'acquisition',
        card: (
          <img
            src="/images/BRRRRCards/AcquisitionExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'income',
        card: (
          <img
            src="/images/BRRRRCards/GrossIncome.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'expenses',
        card: (
          <img
            src="/images/BRRRRCards/MonthlyExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'rehab',
        card: (
          <img
            src="/images/BRRRRCards/RehabExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'financing',
        card: (
          <img
            src="/images/BRRRRCards/Loans.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'projection',
        card: (
          <img
            src="/images/BRRRRCards/ValueOverTime.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'cashPositioning',
        card: (
          <img
            src="/images/BRRRRCards/CashPositioning.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'disposition',
        card: (
          <img
            src="/images/fixAndFlipCards/DispositionExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'comparableProperties',
        card: (
          <img
            src="/images/universalStrategyCards/CompsCard.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'deactive',
        card: (
          <Card variant="outlined" sx={{ width: '100%' }}>
            <div
              style={{ display: 'flex', alignItems: 'center', paddingTop: '0.75rem', paddingBottom: '0.75rem', paddingLeft: '1.25rem', paddingRight: '1.25rem', marginBottom: 5, marginTop: 5, backgroundColor: '#fff' }}
            >
              <Box sx={{
                flexGrow: 1,
                minWidth: 0,
                "& > b": { display: "block" },
                "& > small": {
                  textTransform: "uppercase",
                  display: "block",
                  opacity: 0.3,
                  fontWeight: "bold",
                },
              }}>
                <b>Hide Cards</b>
              </Box>
            </div>
            <Divider />
            <CardContent>
              <Typography>
                All cards past this one will be hidden
              </Typography>
            </CardContent>
          </Card>
        ),
      },
    ],
    (card) => !card.hide,
  )

  const shortTermRentalCards = filter(
    [
      {
        name: 'strategy',
        card: (
          <img
            src="/images/shortTermRentalCards/Summary.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'targets',
        card: (
          <img
            src="/images/shortTermRentalCards/Targets.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'monthlyCashflow',
        card: (
          <img
            src="/images/shortTermRentalCards/Cashflow.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'acquisition',
        card: (
          <img
            src="/images/shortTermRentalCards/AcquisitionExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'income',
        card: (
          <img
            src="/images/shortTermRentalCards/Income.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'expenses',
        card: (
          <img
            src="/images/shortTermRentalCards/MonthlyExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'rehab',
        card: (
          <img
            src="/images/shortTermRentalCards/RehabExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'financing',
        card: (
          <img
            src="/images/shortTermRentalCards/Financing.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'projection',
        card: (
          <img
            src="/images/shortTermRentalCards/Assumptions.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'cashPositioning',
        card: (
          <img
            src="/images/shortTermRentalCards/CashPositioning.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'disposition',
        card: (
          <img
            src="/images/shortTermRentalCards/DispositionExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'comparableProperties',
        card: (
          <img
            src="/images/universalStrategyCards/CompsCard.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'deactive',
        card: (
          <Card variant="outlined" sx={{ width: '100%' }}>
            <div
              style={{ display: 'flex', alignItems: 'center', paddingTop: '0.75rem', paddingBottom: '0.75rem', paddingLeft: '1.25rem', paddingRight: '1.25rem', marginBottom: 5, marginTop: 5, backgroundColor: '#fff' }}
            >
              <Box sx={{
                flexGrow: 1,
                minWidth: 0,
                "& > b": { display: "block" },
                "& > small": {
                  textTransform: "uppercase",
                  display: "block",
                  opacity: 0.3,
                  fontWeight: "bold",
                },
              }}>
                <b>Hide Cards</b>
              </Box>
            </div>
            <Divider />
            <CardContent>
              <Typography>
                All cards past this one will be hidden
              </Typography>
            </CardContent>
          </Card>
        ),
      },
    ],
    (card) => !card.hide,
  )

  const buildToRentCards = filter(
    [
      {
        name: 'strategy',
        card: (
          <img
            src="/images/buildToRentCards/Summary.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'targets',
        card: (
          <img
            src="/images/buildToRentCards/Targets.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'monthlyCashflow',
        card: (
          <img
            src="/images/buildToRentCards/Cashflow.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'income',
        card: (
          <img
            src="/images/buildToRentCards/Income.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'expenses',
        card: (
          <img
            src="/images/buildToRentCards/MonthlyExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'financing',
        card: (
          <img
            src="/images/buildToRentCards/Financing.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'endFinancing',
        card: (
          <img
            src="/images/buildToRentCards/EndFinancing.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'projection',
        card: (
          <img
            src="/images/buildToRentCards/Assumptions.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'cashPositioning',
        card: (
          <img
            src="/images/buildToRentCards/CashPositioning.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'disposition',
        card: (
          <img
            src="/images/buildToRentCards/DispositionExpenses.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'comparableProperties',
        card: (
          <img
            src="/images/universalStrategyCards/CompsCard.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'deactive',
        card: (
          <Card variant="outlined" sx={{ width: '100%' }}>
            <div
              style={{ display: 'flex', alignItems: 'center', paddingTop: '0.75rem', paddingBottom: '0.75rem', paddingLeft: '1.25rem', paddingRight: '1.25rem', marginBottom: 5, marginTop: 5, backgroundColor: '#fff' }}
            >
              <Box sx={{
                flexGrow: 1,
                minWidth: 0,
                "& > b": { display: "block" },
                "& > small": {
                  textTransform: "uppercase",
                  display: "block",
                  opacity: 0.3,
                  fontWeight: "bold",
                },
              }}>
                <b>Hide Cards</b>
              </Box>
            </div>
            <Divider />
            <CardContent>
              <Typography>
                All cards past this one will be hidden
              </Typography>
            </CardContent>
          </Card>
        ),
      },
    ],
    (card) => !card.hide,
  )

  const wholesaleCards = filter(
    [
      {
        name: 'bigPicture',
        hide: !activeOrg?.isRealeflow,
        card: (
          <img
            src="/images/wholesaleCards/BigPicture.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'bigPictureSummary',
        hide: !activeOrg?.isRealeflow,
        card: (
          <img
            src="/images/wholesaleCards/BigPictureSummary.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'strategy',
        card: (
          <img
            src="/images/wholesaleCards/Summary.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'targets',
        card: (
          <img
            src="/images/wholesaleCards/Targets.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'netProfit',
        card: (
          <img
            src="/images/wholesaleCards/NetProfit.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'wholesale',
        card: (
          <img
            src="/images/wholesaleCards/Wholesale.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'comparableProperties',
        card: (
          <img
            src="/images/universalStrategyCards/CompsCard.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'deactive',
        card: (
          <Card variant="outlined" sx={{ width: '100%' }}>
            <div
              style={{ display: 'flex', alignItems: 'center', paddingTop: '0.75rem', paddingBottom: '0.75rem', paddingLeft: '1.25rem', paddingRight: '1.25rem', marginBottom: 5, marginTop: 5, backgroundColor: '#fff' }}
            >
              <Box sx={{
                flexGrow: 1,
                minWidth: 0,
                "& > b": { display: "block" },
                "& > small": {
                  textTransform: "uppercase",
                  display: "block",
                  opacity: 0.3,
                  fontWeight: "bold",
                },
              }}>
                <b>Hide Cards</b>
              </Box>
            </div>
            <Divider />
            <CardContent>
              <Typography>
                All cards past this one will be hidden
              </Typography>
            </CardContent>
          </Card>
        ),
      },
    ],
    (card) => !card.hide,
  )

  const BORCards = filter(
    [
      {
        name: 'strategy',
        card: (
          <img
            src="/images/BORCards/Summary.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'targets',
        card: (
          <img
            src="/images/BORCards/Targets.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'BOR',
        card: (
          <img
            src="/images/BORCards/BOR.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'BORInputs',
        card: (
          <img
            src="/images/BORCards/BORInputs.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'comparableProperties',
        card: (
          <img
            src="/images/universalStrategyCards/CompsCard.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'deactive',
        card: (
          <Card variant="outlined" sx={{ width: '100%' }}>
            <div
              style={{ display: 'flex', alignItems: 'center', paddingTop: '0.75rem', paddingBottom: '0.75rem', paddingLeft: '1.25rem', paddingRight: '1.25rem', marginBottom: 5, marginTop: 5, backgroundColor: '#fff' }}
            >
              <Box sx={{
                flexGrow: 1,
                minWidth: 0,
                "& > b": { display: "block" },
                "& > small": {
                  textTransform: "uppercase",
                  display: "block",
                  opacity: 0.3,
                  fontWeight: "bold",
                },
              }}>
                <b>Hide Cards</b>
              </Box>
            </div>
            <Divider />
            <CardContent>
              <Typography>
                All cards past this one will be hidden
              </Typography>
            </CardContent>
          </Card>
        ),
      },
    ],
    (card) => !card.hide,
  )

  const astroflipCards = filter(
    [
      {
        name: 'strategy',
        card: (
          <img
            src="/images/wholesaleCards/Summary.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'targets',
        card: (
          <img
            src="/images/wholesaleCards/Targets.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'netProfit',
        card: (
          <img
            src="/images/wholesaleCards/NetProfit.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'astroflip',
        card: (
          <img
            src="/images/wholesaleCards/Wholesale.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'comparableProperties',
        card: (
          <img
            src="/images/universalStrategyCards/CompsCard.png"
            alt=""
            style={{ width: '100%' }}
          />
        ),
      },
      {
        name: 'deactive',
        card: (
          <Card variant="outlined" sx={{ width: '100%' }}>
            <div
              style={{ display: 'flex', alignItems: 'center', paddingTop: '0.75rem', paddingBottom: '0.75rem', paddingLeft: '1.25rem', paddingRight: '1.25rem', marginBottom: 5, marginTop: 5, backgroundColor: '#fff' }}
            >
              <Box sx={{
                flexGrow: 1,
                minWidth: 0,
                "& > b": { display: "block" },
                "& > small": {
                  textTransform: "uppercase",
                  display: "block",
                  opacity: 0.3,
                  fontWeight: "bold",
                },
              }}>
                <b>Hide Cards</b>
              </Box>
            </div>
            <Divider />
            <CardContent>
              <Typography>
                All cards past this one will be hidden
              </Typography>
            </CardContent>
          </Card>
        ),
      },
    ],
    (card) => !card.hide,
  )

  // const getOrderDefault = (storedValues = [], Cards) => {
  //   const newCards = difference(
  //     map(
  //       filter(Cards, (card) => !card.hide),
  //       (card) => card.name,
  //     ),
  //     storedValues,
  //   )
  //   console.log(storedValues)
  //   console.log(newCards)
  //   const deactiveIndex = findIndex(
  //     storedValues,
  //     (value) => value === 'deactive',
  //   )
  //   return concat(
  //     slice(storedValues, 0, deactiveIndex),
  //     newCards,
  //     slice(storedValues, deactiveIndex),
  //   )
  // }

  return [
    {
      buyAndHoldCards,
      fixAndFlipCards,
      turnkeyCards,
      BRRRRCards,
      shortTermRentalCards,
      buildToRentCards,
      wholesaleCards,
      BORCards,
      astroflipCards,
    },
    // {
    //   getOrderDefault,
    // },
  ]
}

export default usePreferences
